import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import { CoreService } from "../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { IPublicPackage } from "src/app/interfaces/publicPackage";

@Injectable({
  providedIn: "root"
})
export class PackagePublicService {
  constructor(private core: CoreService) {}

  list(page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.packagePublic.list,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }

  getById(id: number): Observable<any> {
    return this.core.get(
      ServiceRoute.packagePublic.getById + id,
      new CommonHttpOption().headers
    );
  }

  add(data: IPublicPackage): Observable<any> {
    return this.core.post(
      ServiceRoute.packagePublic.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: IPublicPackage): Observable<any> {
    return this.core.put(
      ServiceRoute.packagePublic.edit,
      data,
      new CommonHttpOption().headers
    );
  }
}
